/** Shared fallback UI rendered by the top-level ErrorBoundary AND the TanStack Router `defaultErrorComponent`. Rendering-only; error reporting is handled by the parent that mounts this. */
export function ErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 p-6">
      <div className="max-w-md text-center">
        <h1 className="text-xl font-semibold text-neutral-900 mb-2">Something went wrong</h1>
        <p className="text-sm text-neutral-600 mb-6">It has been reported to our team.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="inline-flex items-center px-4 py-2 bg-neutral-900 hover:bg-neutral-800 text-white rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:ring-offset-2"
        >
          Reload page
        </button>
      </div>
    </div>
  );
}
